export default __webpack_public_path__ + "static/media/how.18d0693b.png";